















































import { Watch, Component, Prop, Vue } from "vue-property-decorator";
import ChoiceScorerGroup from "@/views/ChoiceViewpointsScorer/ChoiceViewpointsScorerRecursiveGroup.vue";
import ViewpointCard from "@/components/common/ViewpointCard.vue";
import { getModule } from 'vuex-module-decorators';
import Viewpoints from "@/store/modules/Viewpoints";
import Scoring from "@/store/modules/Scoring";

import Decisions from "@/store/modules/Decisions";
import StorageImage from "@/components/common/StorageImage.vue";
import Choices from "@/store/modules/Choices";
import ScoringKeyEditorDialog from "@/components/scoring-key/ScoringKeyEditorDialog.vue";
import WorkspaceOptions from "@/store/modules/WorkspaceOptions";
import ViewpointChoiceScore from "@/components/scoring-input/ViewpointChoiceScore.vue";
import Colors from "@/utils/Colors";
import Sticky from 'vue-sticky-directive';
import Modelling from "@/store/modules/Modelling";
import ApexBarChart from "@/components/common/ApexBarChart.vue";
import RadialChart from "@/components/common/RadialChart.vue";
import { FactorGroup } from "@/api/model/FactorResource";
import ApexChart from "@/components/common/ApexChart.vue"
import { VIEWPOINT_API } from "@/api/ViewpointApi";

const modellingModule = getModule(Modelling)
const viewpointsModule = getModule(Viewpoints)
const decisionsModule = getModule(Decisions);
const scoringModule = getModule(Scoring);
const choicesModule = getModule(Choices);
const workspaceOptionsModule = getModule(WorkspaceOptions);
interface dataValue {
    labels: string[];
    scores: number[];    
}
@Component({
    components: {
        ViewpointChoiceScore,
        ScoringKeyEditorDialog,
        StorageImage,
        ChoiceScorerGroup,
        ViewpointCard,
        ApexBarChart,
        ApexChart,
        RadialChart
    },
    directives: {
        Sticky,
    },
})
export default class Results extends Vue {

    @Prop({default: false, type: Boolean})
    hideTitle: boolean;

    @Prop({default: false, type: Boolean})
    viewpointVisibility: boolean;

    @Prop({default: true, type: Boolean})
    groupSummary: boolean;

    private hoverTitle = false;
    private redraw: number = 0;
    private colors = Colors.COLORS;

    get thisRoute() {
        return this.$route.fullPath;
    }

    @Watch('thisRoute')
    onThisRouteChange() {
        // setTimeout(() => this.redraw++, 1000);
    }

    get chartOptions() {
        return {
            chart: {
                height: 280,
                type: "radialBar",
            },
            series: [Number(this.scoreTotal).toFixed(0)],
            colors: ["#0A4B71"],
            plotOptions: {
                radialBar: {
                    startAngle: -90,
                    endAngle: 90,
                    track: {
                        background: "#e7e7e7",
                        strokeWidth: '97%',
                        margin: 5, // margin is in pixels
                        dropShadow: {
                            enabled: false,
                            top: 2,
                            left: 0,
                            color: '#999',
                            opacity: 1,
                            blur: 2
                        }
                    },
                    dataLabels: {
                        name: {
                            show: true,
                            fontSize: '14px',
                            fontFamily: 'Nunito',
                            fontWeight: 300,
                            color: '#0A4B71',
                            offsetY: 24
                        },
                        value: {
                            show: true,
                            fontSize: '36px',
                            fontFamily: 'Nunito',
                            fontWeight: 900,
                            color: '#0A4B71',
                            offsetY: -16,
                            formatter: function (val: any) {
                                return val;
                            },
                            total: {
                                show: true,
                                label: 'Total',
                                color: '#0A4B71',
                                fontSize: '16px',
                                fontFamily: undefined,
                                fontWeight: 600,
                                formatter: function (w: any) {
                                    return w.globals.seriesTotals.reduce((a: any, b: any) => {
                                    return a + b
                                    }, 0) / w.globals.series.length + '%'
                                }
                            }
                        },
                    }
                }
                },
                grid: {
                    padding: {
                        top: -10
                    }
                },
                fill: {
                type: 'gradient',
                gradient: {
                    shade: 'light',
                    shadeIntensity: 0.1,
                    inverseColors: false,
                    opacityFrom: 1,
                    opacityTo: 0.8,
                    stops: []
                },
            },
            labels: [`out of ${this.scoringRangeMax}`],
        }
    };
    
    get factorResources() {
        return modellingModule.publishedModelFactorResources;
    }

    get choices() {
        return choicesModule.choices;
    }

    get choicesList() {
        return choicesModule.choicesList;
    }

    get selectedChoice() {
        return choicesModule.selectedChoice;
    };

    set selectedChoice(selectedChoice: any) {
        if (selectedChoice) {
            choicesModule.setSelectedChoiceId(selectedChoice.id);
        } else {
            choicesModule.setSelectedChoiceId(null);
        }
    }

    get scoredChoices() {
        return scoringModule.viewpointScores;
    }

    get selectedDecision() {
        return decisionsModule.selectedDecision;
    }

    get selectedViewpoints() {
        return viewpointsModule.selectedViewpoints;
    }

    get viewpointScoresLoaded() {
        if (this.selectedViewpoints) {
            return this.selectedViewpoints.map(v => v.viewpointId)
                .filter(vId => !this.scoredChoices.hasOwnProperty(vId))
                .length === 0
        }
        return false;
    }

    get modifiedViewpoints() {
        if (this.selectedViewpoints) {
            return this.selectedViewpoints.filter((vp: any) => vp.changed)
        }
    }

    get loading() {
        return !this.selectedViewpoints
            || !this.scoredChoices
            || !this.viewpointScoresLoaded
    }

    get topGroupData() {
        let topGroups = (this.factorResources['M'] as FactorGroup).childrenIds
        let data: dataValue = {'labels':[], 'scores':[]};
        if(viewpointsModule.activeViewpointId && this.selectedChoice && this.viewpointScoresLoaded) {
            for(let factor of topGroups) {
                data.labels.push(this.factorResources[factor].name);
                data.scores.push(Number(((scoringModule.viewpointScores[viewpointsModule.activeViewpointId].choiceScores[this.selectedChoice.id].choiceFactorScores[factor].score)* this.scoringRangeMax).toFixed(1)));
            }
        }
        return data;
    } 

    get scores(): any[] {
        return this.topGroupData.scores || [];
    }
    get scoreTotal() {
        return this.scores.reduce((a, b) => a + b, 0)/this.scores.length;
    }

    get labels(): any[] {
        return this.topGroupData.labels || [];
    }

    get scoringSuffix() {
        if(workspaceOptionsModule.customRangeActive)
            return decisionsModule.scoringSuffix
        else
            return '%'
    }

    get scoringRangeMax() {
        if(workspaceOptionsModule.customRangeActive)
            return decisionsModule.scoringRangeMax
        else
            return 100
    }

    private async getData() {
        
    }
}
